var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { RouteContextProvider, useSetRouteContext, } from '@faire/web/common/routes/useRouteContext';
import { Route as WebRoute } from '@faire/web/ui/routing/Route';
import React, { useEffect } from 'react';
const RouteBase = (props) => {
    const { path, productArea, pod, pillar, templatedPath, component: Component, render } = props, otherProps = __rest(props, ["path", "productArea", "pod", "pillar", "templatedPath", "component", "render"]);
    const setRouteContext = useSetRouteContext();
    useEffect(() => {
        setRouteContext({
            pod,
            pillar,
            productArea,
            templatedPath,
        });
    }, [templatedPath, productArea, pod, pillar, setRouteContext]);
    return (React.createElement(WebRoute, Object.assign({ path: path, render: (props) => (React.createElement(React.Fragment, null,
            Component ? React.createElement(Component, Object.assign({}, props)) : null, render === null || render === void 0 ? void 0 :
            render(props))) }, otherProps)));
};
/**
 * Route is a web-api specific thin wrapper around a react-router-dom Route, that
 * appends context of the product area associated with the web-api route (and
 * propagates it to DataDog DD_RUM).
 *
 * NOTE(luke): We can't simplify use of the Route tag API because the React Router Switch tag
 * makes use of the `path` prop on the direct descendant. This means we have to leverage the
 * Route tag in a shallow/repetitive way, which might look stupid, but it's necessary.
 * e.g. you can't do this:
 * ```
 * export const ReactRoute = () => <Route path={route} product_area={SOMETHING} .../>
 *
 * import { ReactRoute as MyRoute } from "../../routes/my-route";
 * <Switch>
 *   <MyRoute />
 * </Switch>
 * ```
 * The result is that `MyRoute` will always render - `Switch` treats it like a pathless
 * Route, since it doesn't (appear to) have a path prop. Instead, we simply have to have
 * to ensure `path` is a prop we specify at the node, e.g.
 * ```
 * import { props as myRouteProps } from "../../routes/my-route";
 * <Switch>
 *   <Route {...myRouteProps} />
 * </Switch>
 * ```
 */
export const Route = (props) => {
    return (React.createElement(RouteContextProvider, null,
        React.createElement(RouteBase, Object.assign({}, props))));
};
